// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./front/front.scss
// module id = 9
// module chunks = 1